import { useEffect } from 'react';

export const useUnmount = (callback: () => void | undefined) => {
  useEffect(
    () => {
      return callback;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
